import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, exhDescriptionActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import Pagination from "../../../../../utils/pagination";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { insertUpdateExhSeminar_action, getExhSeminarDetails_action, deleteExhSeminar_action } from '../../../../../actions/admin_module_action/master_action/exhibition_master_action/exh_seminar_action';

class Exh_seminar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            ExihibitionID: '',
            seminarList: [
                {
                    SeminarID: '',
                    C_SeminarID: '',
                    id: 1,
                    SeqNo: 1,
                    parentId: 1,
                    isParent: true,
                    isChild: false,
                    Day: '',
                    DateTime: null,
                    Description: '',
                    Speaker: '',
                    All: false,
                    Exhibitor: false,
                    Visitor: false,
                    Delegate: false,
                }
            ]
        }
    }

    componentDidMount() {
        this.getFillList(exhDescriptionActionId, '', '', '')

        this.setState({
            ExihibitionID: (this.props.location.state != null && this.props.location.state.ExihibitionID != null && this.props.location.state.ExihibitionID != undefined) ? this.props.location.state.ExihibitionID : (this.props.id != null && this.props.id != undefined ? this.props.id : ''),
        })
        setTimeout(() => {
            console.log(this.state.ExihibitionID)

            this.getExhSeminarDetails()
        }, 200);
    }

    getFillList(value, userID, keyword, keyvalue) {
        // this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID, keyword != '' ? keyword : null, keyvalue != '' ? keyvalue : null)
            .then((data) => {
                if (data.error != 1) {
                    if (value == exhDescriptionActionId) {
                        this.setState({
                            DescriptionList: data.data,
                            tempDescriptionList: data.data,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    getExhSeminarDetails() {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getExhSeminarDetails_action(ExihibitionID)
            .then((data) => {
                if (!data) {
                    this.setState({ isLoading: false })
                    toastError("Failed to fetch seminar details.")
                    return
                }
                if (data.error != 1) {
                    const rawList = Array.isArray(data.data) ? data.data : []
                    if (rawList.length > 0) {
                        const seminars = [...rawList].sort((a, b) => a.SeqNo - b.SeqNo);
                        const output = [];
                        let parentCounter = 1;

                        seminars.forEach(seminar => {
                            const row = { ...seminar };
                            row.Exhibitor = seminar.IsExhibitor
                            row.Visitor = seminar.IsVisitor
                            row.Delegate = seminar.IsDelegate
                            row.Date = seminar.Date ? moment(seminar.Date, 'YYYY-MM-DD').toDate() : null
                            row.StartTime = seminar.StartTime ? moment(seminar.StartTime).utc().format("HH:mm") : null
                            row.EndTime = seminar.EndTime ? moment(seminar.EndTime).utc().format("HH:mm") : null
                            row.All = !!(row.Exhibitor && row.Visitor && row.Delegate)
                            row.isDirty = false

                            if (seminar.ParentSeminarID === null || seminar.ParentSeminarID === undefined) {
                                row.id = parentCounter;
                                row.parentId = parentCounter;
                                row.isParent = true
                                row.isChild = false
                                output.push(row);
                                parentCounter += 1;
                            } else {
                                const parentSeminar = output.find(s => s.SeminarID === seminar.ParentSeminarID);
                                if (parentSeminar) {
                                    const childCount = output.filter(s => s.ParentSeminarID === seminar.ParentSeminarID).length;
                                    row.parentId = parentSeminar.parentId;
                                    row.id = parseFloat(`${parentSeminar.id}.${childCount + 1}`);
                                    row.isParent = false
                                    row.isChild = true
                                    output.push(row);
                                }
                            }
                        });

                        output.forEach((item, idx) => { item.SeqNo = idx + 1 });
                        console.log("result--------->", output)
                        this.setState({ seminarList: output })
                    }
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    deleteExhSeminarDetails(id) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.deleteExhSeminar_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.getExhSeminarDetails();
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateExhSeminar() {
        const { ExihibitionID, seminarList } = this.state
        this.setState({ isLoading: true })
        const parentList = []
        const childList = []

        // Only send rows that were actually changed or are new
        seminarList.filter(item => item.isDirty).map((item) => {
            if (item.isParent) {
                parentList.push({
                    P_SeminarID: item.SeminarID || '',
                    P_ParentNo: item.parentId,
                    P_Day: item.Day,
                    P_DateTime: item.DateTime,
                    P_Description: item.Description,
                    P_Speaker: item.Speaker,
                    P_SeqNo: item.SeqNo,
                    P_IsExhibitor: item.Exhibitor ? 1 : 0,
                    P_IsVisitor: item.Visitor ? 1 : 0,
                    P_IsDelegate: item.Delegate ? 1 : 0,
                })
            } else {
                childList.push({
                    C_SeminarID: item.SeminarID || '',
                    C_ParentNo: item.parentId,
                    C_Day: item.Day,
                    C_DateTime: item.DateTime,
                    C_Description: item.Description,
                    C_Speaker: item.Speaker,
                    C_SeqNo: item.SeqNo,
                    C_IsExhibitor: item.Exhibitor ? 1 : 0,
                    C_IsVisitor: item.Visitor ? 1 : 0,
                    C_IsDelegate: item.Delegate ? 1 : 0,
                })
            }
        })

        console.log("parentList--->", parentList)
        console.log("childList--->", childList)

        if (parentList.length === 0 && childList.length === 0) {
            toastError("No changes to save.")
            this.setState({ isLoading: false })
            return
        }

        this.props.insertUpdateExhSeminar_action(ExihibitionID, parentList, childList)
            .then((data) => {
                if (data.error != 1) {
                    this.getExhSeminarDetails()
                    toastSuccess("data updated Successfuly!")
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    addChild(parentId, position = null) {
        const { seminarList } = this.state;
        const parentIndex = seminarList.findIndex(item => item.id === parentId);
        if (parentIndex === -1) return;

        const parentBaseId = Math.floor(parentId);
        const children = seminarList.filter(item => Math.floor(item.id) === parentBaseId && !item.isParent);
        const newChildNum = children.length + 1;
        const newId = parseFloat(`${parentBaseId}.${newChildNum}`);

        const newItem = {
            id: newId,
            SeqNo: 0,
            parentId: parentBaseId,
            isParent: false,
            isChild: true,
            Day: '',
            DateTime: null,
            Description: '',
            Speaker: '',
            All: false,
            Exhibitor: false,
            Visitor: false,
            Delegate: false,
            SeminarID: '',
            ParentSeminarID: seminarList[parentIndex].SeminarID || null,
            isDirty: true
        };

        const insertIndex = position !== null ? position : parentIndex + 1;
        const updated = [...seminarList];
        updated.splice(insertIndex, 0, newItem);

        // Re-number children for this parent
        let childCounter = 1;
        for (let i = 0; i < updated.length; i++) {
            if (Math.floor(updated[i].id) === parentBaseId && !updated[i].isParent) {
                updated[i] = { ...updated[i], id: parseFloat(`${parentBaseId}.${childCounter}`) };
                childCounter++;
            }
        }
        updated.forEach((item, idx) => { item.SeqNo = idx + 1 });
        this.setState({ seminarList: updated });
    }

    addParent() {
        const { seminarList } = this.state
        const parentCount = seminarList.filter(d => d.isParent).length;
        const newParent = {
            id: parentCount + 1,
            parentId: parentCount + 1,
            SeqNo: seminarList.length + 1,
            isParent: true,
            isChild: false,
            Day: '',
            DateTime: null,
            Description: '',
            Speaker: '',
            All: false,
            Exhibitor: false,
            Visitor: false,
            Delegate: false,
            SeminarID: '',
            ParentSeminarID: null,
            isDirty: true
        };
        this.setState({ seminarList: [...seminarList, newParent] })
    }

    checkForDuplicates(arr, keys) {
        const seen = new Set();
        for (const obj of arr) {
            const uniqueKey = keys.map(key => obj[key]).join('|');
            if (seen.has(uniqueKey)) {
                return true; // Duplicate found
            }
            seen.add(uniqueKey);
        }
        return false; // No duplicates found
    }


    deleteExhSeminarList(id, SeminarID) {
        const { seminarList } = this.state;
        if (SeminarID != '') {
            this.deleteExhSeminarDetails(SeminarID)
        } else {
            // Identify if the item to be deleted is a parent
            const itemToDelete = seminarList.find(item => item.id === id);
            const isParent = itemToDelete.isParent;

            let updatedList;

            if (isParent) {
                // Delete the parent and all its children
                const parentBaseId = Math.floor(id);
                updatedList = seminarList.filter(item => Math.floor(item.id) !== parentBaseId);
            } else {
                // Delete only the child
                updatedList = seminarList.filter(item => item.id !== id);
            }

            // Reassign IDs for remaining parents and their children
            let parentCounter = 1;
            updatedList = updatedList.map((item) => {
                if (item.isParent) {
                    // Update parent ID to be sequential
                    const newParentId = parentCounter;
                    const oldParentId = Math.floor(item.id);

                    // Update this parent ID
                    item.id = newParentId;
                    item.parentId = newParentId;

                    // Update all its children IDs
                    let childCounter = 1;
                    updatedList.forEach(childItem => {
                        if (Math.floor(childItem.id) === oldParentId && !childItem.isParent) {
                            childItem.id = parseFloat(`${newParentId}.${childCounter}`);
                            childCounter++;
                        }
                    });

                    parentCounter++;
                }
                return item;
            });

            if (updatedList.length > 0) {
                updatedList.map((item, i) => {
                    item.SeqNo = i + 1
                })
                console.log('seminarList Delete----->', updatedList);
                this.setState({ seminarList: updatedList });
            } else {
                this.setState({
                    seminarList: [
                        {
                            id: 1,
                            SeqNo: 1,
                            isParent: true,
                            isChild: false,
                            Day: '',
                            DateTime: null,
                            Description: '',
                            Speaker: '',
                            All: false,
                            Exhibitor: false,
                            Visitor: false,
                            Delegate: false,
                        }
                    ]
                });
            }
        }
    }


    onInputChange(e, i, param) {
        const updated = this.state.seminarList.map((data, index) => {
            if (i !== index) return data;
            const row = { ...data, isDirty: true };
            if (param === 'Day') row.Day = e.target.value;
            else if (param === 'DateTime') row.DateTime = e.target.value;
            else if (param === 'StartTime') row.StartTime = e.target.value;
            else if (param === 'EndTime') row.EndTime = e.target.value;
            else if (param === 'Description') row.Description = e.target.value;
            else if (param === 'Speaker') row.Speaker = e.target.value;
            else if (param === 'All') {
                const checked = e.target.checked;
                row.All = checked;
                row.Exhibitor = checked;
                row.Visitor = checked;
                row.Delegate = checked;
            } else if (param === 'Exhibitor') {
                row.Exhibitor = e.target.checked;
                row.All = !!(row.Exhibitor && row.Visitor && row.Delegate);
            } else if (param === 'Visitor') {
                row.Visitor = e.target.checked;
                row.All = !!(row.Exhibitor && row.Visitor && row.Delegate);
            } else if (param === 'Delegate') {
                row.Delegate = e.target.checked;
                row.All = !!(row.Exhibitor && row.Visitor && row.Delegate);
            }
            return row;
        });

        // Propagate checkbox changes: if child changed, mark parent dirty too
        if (['All', 'Exhibitor', 'Visitor', 'Delegate'].includes(param)) {
            const changedRow = updated[i];
            if (!changedRow.isParent) {
                // Mark parent row as dirty so it gets sent to SP
                const parentIdx = updated.findIndex(d => d.isParent && d.parentId === changedRow.parentId);
                if (parentIdx !== -1) {
                    updated[parentIdx] = { ...updated[parentIdx], isDirty: true };
                }
            }
        }

        this.setState({ seminarList: updated });
    }


    record(seminarList) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr style={{ border: '1px solid #ccc' }}>
                        <th className="text-center">Seq No</th>
                        <th className="text-left">Day</th>
                        <th className="text-left">Date and Time</th>
                        <th className="text-left">Description</th>
                        <th className="text-center">Speaker</th>
                        <th className="text-center">All</th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Visitor</th>
                        <th className="text-center">Delegate</th>
                        <th className="text-center">Action</th>

                    </tr>
                </thead>
                <tbody >
                    {
                        seminarList != '' && seminarList != null ? (
                            seminarList.map((data, i) => (
                                <tr key={i} className={data.isParent ? "" : ''}>
                                    {/* {data.isParent ? <td >{data.id}</td> : <td ></td >} */}
                                    <td >{data.id}</td>

                                    <td >
                                        <input className="form-control"
                                            style={{ width: '200px' }}
                                            type="text"
                                            value={data.Day}
                                            onChange={(e) => this.onInputChange(e, i, 'Day')}
                                        />
                                    </td>
                                    <td>
                                        <input className="form-control"
                                            style={{ width: '400px' }}
                                            type="text"
                                            value={data.DateTime}
                                            onChange={(e) => this.onInputChange(e, i, 'DateTime')}
                                        />
                                    </td>
                                    <td>
                                        <input className="form-control"
                                            style={{ width: '700px' }}
                                            type="text"
                                            value={data.Description}
                                            onChange={(e) => this.onInputChange(e, i, 'Description')}
                                        />
                                    </td>
                                    <td>
                                        <input className="form-control"
                                            style={{ width: '700px' }}
                                            type="text"
                                            value={data.Speaker}
                                            onChange={(e) => this.onInputChange(e, i, 'Speaker')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <input
                                            style={{ marginTop: '12px' }}
                                            type="checkbox"
                                            checked={data.All}
                                            onChange={(e) => this.onInputChange(e, i, 'All')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <input
                                            style={{ marginTop: '12px' }}
                                            type="checkbox"
                                            checked={data.Exhibitor}
                                            onChange={(e) => this.onInputChange(e, i, 'Exhibitor')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <input
                                            style={{ marginTop: '12px' }}
                                            type="checkbox"
                                            checked={data.Visitor}
                                            onChange={(e) => this.onInputChange(e, i, 'Visitor')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <input
                                            style={{ marginTop: '12px' }}
                                            type="checkbox"
                                            checked={data.Delegate}
                                            onChange={(e) => this.onInputChange(e, i, 'Delegate')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <button
                                            title="Add FreightForward"
                                            className="btn btn-sm padding_0"
                                            onClick={() => this.addChild(data.id)}
                                        >
                                            <i className="fa fa-plus grid-icon"></i>
                                        </button>
                                        <button
                                            title="Delete FreightForward"
                                            className="btn btn-sm padding_0"
                                            onClick={() => this.deleteExhSeminarList(data.id, data.SeminarID)}
                                        >
                                            <i className="fa fa-trash grid-icon"></i>
                                        </button>

                                    </td>
                                </tr>
                            ))
                        ) : (<tr><td colSpan={12} className='text-center'>Record not found</td></tr>)
                    }
                </tbody>
            </table>
        )
    }


    render() {
        const { isLoading, seminarList, currentPage } = this.state

        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = seminarList.slice(indexOfFirstRecord, indexOfLastRecord)
        const nPages = Math.ceil(seminarList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />


                    <div className="main-container p-2">
                        <div className="row exb-top-space mx-2" style={{ margin: 'auto' }}>
                            <div className="table-responsive px-0 mt-3">
                                {this.record(seminarList)}
                            </div>
                            <div className="col-md-12 mt-2">
                                <button type="button" className="btn btn-aqua rounded-1" style={{ float: 'right' }}
                                    onClick={() => this.insertUpdateExhSeminar()}>
                                    Save
                                </button>
                                <button className="btn rounded-1 btn-aqua" style={{ float: 'right', marginRight: '10px' }}
                                    onClick={() => this.addParent()}>
                                    Add More Seminar
                                </button>
                            </div>
                            {/* <div className="mt-2 float-left">
                                {seminarList.length > 0 ? <Pagination
                                    nPages={nPages}
                                    currentPage={currentPage}
                                    setCurrentPage={this.updateItem} /> : <></>}

                            </div> */}
                        </div>
                    </div>

                </>

            </>
        );
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateExhSeminar_action, getExhSeminarDetails_action, deleteExhSeminar_action })(Exh_seminar));